import ClearIcon from '@mui/icons-material/Clear'
import { MobileDatePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { IconButton, Typography } from '@mui/material'
import TextField from '@mui/material/TextField'
import I18n from 'i18n-js'
import MaterialUiPhoneNumber from 'material-ui-phone-number'
import { useContext } from 'react'
import { AuthContext } from '../../context/auth'
import { isFirefox } from '../../hooks/browser'
import { dateLocales } from '../../utils'
import { listCountries, transfromLocale } from '../../utils/locale'
import { isPhoneNumber } from '../../validators/validator'
import PasswordField from '../password'
import useStyles from './style'

const InputForm = ({
  allDate = null,
  className = '',
  phone = false,
  date = false,
  withMaxLength,
  sizeDate = null,
  errorDate = null,
  maxLength,
  inputProps,
  onAccept = () => { },
  clear = false,
  inputType,
  ...rest
}) => {
  const { state } = useContext(AuthContext)
  const classes = useStyles()

  if (inputType === "password") {
    return (
      <PasswordField
        {...rest}
        size='medium'
        className={className}
        classes={classes}
        defaultCountry={transfromLocale[state.locale] || listCountries.fr}

      />
    )
  }
  if (!phone && !date) {
    return (
      <TextField
        {...rest}
        size='medium'
        // style={rest.error ? { marginBottom: '24px' } : {}}
        className={
          (!rest.multiline ? classes.input : classes.textArea) + ' ' + className
        }
        defaultCountry={transfromLocale[state.locale] || listCountries.fr}
        inputProps={
          withMaxLength && !inputProps
            ? { maxLength: maxLength ?? 250 }
            : { ...(inputProps ?? {}) }
        }
      />
    )
  } else if (phone) {
    return (
      <MaterialUiPhoneNumber
        {...rest}
        size='medium'
        error={rest?.value ? !isPhoneNumber(rest?.value) : false}
        helperText={
          rest?.value
            ? !isPhoneNumber(rest?.value) && (
              <Typography variant="caption" color="error">
                {I18n.t('validators.invalidPhone')}
              </Typography>
            )
            : ''
        }
        disableDropdown={isFirefox()}
        style={{ height: 'max-content' }}
        // style={rest.error ? { marginBottom: '24px' } : {}}
        className={classes.input + ' ' + className}
        inputProps={{ maxLength: 250 }}
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value))
            .toString()
            .slice(0, 14)
        }}
      />
    )
  } else if (date) {
    // sacamos solo lo que necesitamos, pero dejamos value/onChange dentro de restDateProps
    const { minDate, maxDate, sx, ...restDateProps } = rest;

    const finalMaxDate =
      allDate === null
        ? (maxDate || new Date()) // si no pasas maxDate, usa hoy
        : maxDate;                // si allDate !== null, respeta lo que venga

    const isValidInRange = (dateValue) => {
      if (!dateValue) return false;

      if (minDate && dateValue < minDate) return false;
      if (finalMaxDate && dateValue > finalMaxDate) return false;

      return true;
    };

    const handleAccept = (dateValue) => {
      // sin restricciones → acepta normal
      if (!minDate && !finalMaxDate) {
        onAccept(dateValue);
        return;
      }

      // con restricciones → solo acepta si está en rango
      if (isValidInRange(dateValue)) {
        onAccept(dateValue);
      }
    };

    const handleClear = () => {
      // limpiamos el valor en el padre
      onAccept(undefined);
      // dejamos que el padre controle el value; no tocamos onChange aquí
    };

    // para saber si mostramos el botón de limpiar
    const hasValue = Boolean(restDateProps.value);

    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={dateLocales[state.locale]}
      >
        <MobileDatePicker
          toolbarTitle=""
          onAccept={handleAccept}
          minDate={minDate}
          maxDate={finalMaxDate}
          inputFormat={I18n.t('general.dateFormat') || 'dd-MM-yyyy'}
          {...restDateProps}          // 👈 aquí siguen yendo value y onChange
          size="medium"
          renderInput={(props) => (
            <TextField
              {...props}
              error={errorDate === null ? props.error : errorDate}
              size={sizeDate !== null ? sizeDate : ''}
              inputvariant="outlined"
              className={classes.input + ' ' + className}
              sx={sx ?? {}}
              InputProps={{
                ...props.InputProps,
                endAdornment: clear ? (
                  <>
                    {props.InputProps?.endAdornment}
                    {hasValue && (
                      <IconButton
                        size="small"
                        onClick={handleClear}
                        aria-label={I18n.t('general.clear') || 'Clear date'}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                  </>
                ) : undefined,
              }}
            />
          )}
        />
      </LocalizationProvider>
    );
  }
}

export default InputForm
